module.exports = __webpack_public_path__ + "static/media/galerija_2022_0052.6e43d3a9.jpg";